<template>
  <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData" :isImmagini="false" :isPrestazioni="true" :isAllegati="false" :btnFirmaVisible="btnFirmaVisible" @updateFirma="onFirmaUpdate">
    <template slot="tab-content-event">
      <visita-gastroenterologica-view-component @update="onUpdateJsonData" :idEvento="id" :key="visitagastroenterologicaViewKey"></visita-gastroenterologica-view-component>
    </template>
  </eventi-view-component>
</template>

<script>
// import VisitagastroenterologicaViewComponent from "./VisitagastroenterologicaViewComponent.vue";

// import axios from "axios";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import VisitaGastroenterologicaViewComponent from "./VisitaGastroenterologicaViewComponent.vue";
export default {
  components: { EventiViewComponent, VisitaGastroenterologicaViewComponent },
  mixins: [UtilityMixin, EventiMixin],
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      titoloEvento: this.getLabelTraduora("patients.gastroenterology.gastroenterologicalVisit"),
      linkback: null,
      linkedit: null,
      jsonData: {},
      btnFirmaVisible: true,
      pathResourceFirma: "/gastrovisitagastroenterologica",
      pathResource: "/gastrovisitagastroenterologica",
      tabIndex: 0,
      id: null,
      pathRestValidation: "/validation",
      isThisFirmato: false,
      showModalLoading: false,
      linkPrintData: null,
      visitagastroenterologicaViewKey: 0,
    };
  },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
  },
  mounted() {
    let me = this;
    me.jsonData.idPaziente = this.$route.query.idPaziente;
    me.id = this.$route.params.id;
    me.visitagastroenterologicaViewKey++;
  },

  methods: {
    updateStatoFirma(firmato) {
      console.log(firmato);
    },
    onFirmaUpdate() {
      let me = this;
      me.btnFirmaVisible = false;
      me.visitagastroenterologicaViewKey++;
    },
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
      if (me.jsonData.firma) {
        me.btnFirmaVisible = false;
      } else {
        me.btnFirmaVisible = true;
      }
      me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
    },
  },
};
</script>

<style></style>
